import { usePhoneRegistrationStore } from '../../../store/phoneRegistrationStore'
import type { IdentityOutcome, PhoneVerifyResult } from '../types/phoneAuth'
import { saveSession } from './saveSession'

type Extra = {
  phone?: string | null
  email?: string | null
  emailVerified?: boolean
}

export const applyVerifyResult = (result: PhoneVerifyResult, extra: Extra = {}): IdentityOutcome => {
  const { setRegistration } = usePhoneRegistrationStore.getState()

  if (result.outcome === 'signed_in' && result.tokens) {
    saveSession(result.tokens)

    return 'signed_in'
  }

  if (result.registration_token) {
    setRegistration({
      token: result.registration_token,
      expiresAt: result.expires_at ?? null,
      outcome: result.outcome as 'found' | 'choose' | 'new',
      candidates: result.candidates ?? [],
      phone: extra.phone ?? null,
      email: extra.email ?? null,
      emailVerified: extra.emailVerified ?? false,
    })
  }

  return result.outcome
}
